/**
 * オープニング
 */

jQuery( function ($) {
    const isInitialVisit = !sessionStorage.getItem('visited');
    const loadingScreen = $('.c-loading');

    if (isInitialVisit) {
        loadingScreen.show();

        const loadingFinished = new Promise((resolve) => {
            $(window).on('load', resolve);
        });
        
        const minimumTimeMet = new Promise((resolve) => {
            setTimeout(resolve, 1500);
        });

        Promise.all([loadingFinished, minimumTimeMet]).then(() => {
            loadingScreen.css('opacity', '0');
            setTimeout(() => {
                loadingScreen.hide();
                
                // 新しいアニメーションステップ
                $('.p-mainvisual__image').css({ transform: 'scale(1.0)', opacity: '1' });
                setTimeout(() => {
                    $('.js-header, .p-mainvisual__copy, .c-notification').css('opacity', '1');
                }, 800);
            }, 300);
        });

        sessionStorage.setItem('visited', 'true');
    } else {
        loadingScreen.hide();

        // 初回訪問以外の時にもアニメーションを実行
        $('.p-mainvisual__image').css({ transform: 'scale(1.0)', opacity: '1' });
        setTimeout(() => {
            $('.js-header, .p-mainvisual__copy, .c-notification').css('opacity', '1');
        }, 800);
    }
});

